export const GET_RATIO_START = "CALCULATOR.GET_RATIO_START";
export const GET_RATIO_SUCCESS = "CALCULATOR.GET_RATIO_SUCCESS";
export const GET_RATIO_FAILED = "CALCULATOR.GET_RATIO_FAILED";
export const FACTOR_UPDATED_SUCCESS = "FACTOR_UPDATED_SUCCESS";
export const FACTOR_ADD_SUCCESS = "FACTOR_ADD_SUCCESS";
